import { useState, useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import {
  AppBar,
  Badge,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  MenuItem,
  Menu,
  List,
  Button,
  ListItemText,
  ListItem,
  Divider,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/NotificationsOutlined";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import Loader from "react-loader-spinner";
// import CircularProgress from '@mui/material/CircularProgress';
import InputIcon from "@material-ui/icons/Input";
import Logo from "./Logo";
import { BaseUrl, endpoints } from "../utils/factory";
import axios from "axios";
// const axios = require('axios');

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const navigate = useNavigate();
  const cmp_id = localStorage.getItem("trans-cmp_id");
  const handlelogout = () => {
    localStorage.clear();
    navigate("/login", { replace: true });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [loaderstate, setLoaderstate] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [clientname, setClientName] = useState("");
  const [notelist, setNoteList] = useState([]);
  const [noteflag, setNoteFlag] = useState(false);
  const [notecount, setNoteCount] = useState("0");
  // const [localData, setLocalData] = useState('');

  const readData = async () => {
    const clientid = localStorage.getItem("tranuserid");
    // console.log('clientid', clientid);
    if (!clientid || clientid === "" || clientid === "null") {
      navigate("/login", { replace: true });
    }
    setClientName(clientid);
  };

  const handleClickNote = async (eta, inv) => {
    setLoaderstate(true);
    const clientid = localStorage.getItem("trans-userId");

    try {
      const response = await axios.post(
        `${BaseUrl}${endpoints.getNoificationCount}`,
        {
          userid: clientid,
          qtype: "5",
          searchtext: "",
          fdate: "",
          tdate: "",
          cmp_id: cmp_id,
        }
      );
      if (response?.data?.recordset?.length > 0) {
        setNoteFlag(true);
        const userdata = response?.data?.recordset;
        setNoteList(userdata);
      } else {
        setNoteFlag(false);
        setNoteList([]);
      }
    } catch (error) {
      console.error("API error", error);
    } finally {
      setLoaderstate(false);
    }
  };

  const handleNoteCount = async () => {
    setLoaderstate(true);
    const clientid = localStorage.getItem("trans-userId");

    try {
      const response = await axios.post(
        `${BaseUrl}${endpoints.getNoificationCount}`,
        {
          userid: clientid,
          qtype: "7",
          searchtext: "",
          fdate: "",
          tdate: "",
          cmp_id: cmp_id,
        }
      );

      console.log("Notification API Response:", response.data);

      const count = response.data?.recordset?.[0]?.Notifications;

      if (count !== undefined && count !== null) {
        console.log("****************", Number(count));

        setNoteCount(Number(count));
      } else {
        setNoteCount(0);
      }
    } catch (error) {
      console.log("Error fetching notification count:", error);
      setNoteCount(0);
    } finally {
      setLoaderstate(false);
    }
  };

  const handleViewAll = () => {
    navigate("/app/products", { replace: true });
  };

  const handleInvoiceTransfer = () => {
    navigate("/app/invoicevarifylist", { replace: true });
  };

  // const handleStockTransfer = () => {
  //   navigate("/app/stocktransfer", { replace: true });
  // };

  const handleDriverList = () => {
    navigate("/app/driver-list", { replace: true });
  };

    const handleRunnerList = () => {
    navigate("/app/runner-list", { replace: true });
  };

  const handleDelivery = () => {
    navigate("/app/delivery-list", { replace: true });
  };

  // const handleViewById = (id) => {
  //   navigate(`/app/notificationDetail/${id}`, { replace: true });
  // };

  useEffect(() => {
    // const clientid = localStorage.getItem('tranuserid');
    // setLocalData(clientid);

    readData();
    handleNoteCount();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      // handleNoteCount();
    }, 5000);
    return () => clearInterval(interval);
  }, [notecount]);

  return (
    <AppBar elevation={0} {...rest}>
      <Toolbar>
        <RouterLink to="/">
          <Logo />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />

        <Button variant="success" onClick={handleRunnerList}>
         Runners List
        </Button>

        {/* <Button variant="success" onClick={handleRunnerImport}>
          Import Runners
        </Button> */}

        {/* <Button variant="success" onClick={handleDriverRegistration}>
          Driver Registration
        </Button> */}

        <Button variant="success" onClick={handleDriverList}>
          Drivers
        </Button>

        <Button variant="success" onClick={handleInvoiceTransfer}>
          Settlements
        </Button>
        {/* ) : null} */}

        {/* <Button variant="success" onClick={handleStockTransfer}>
          other Bookings
        </Button> */}
        <Button variant="success" onClick={handleDelivery}>
          Delivery List
        </Button>
        {clientname}
        <Hidden lgDown>
          <IconButton color="inherit">
            <Badge
              badgeContent={notecount}
              color="error"
              showZero={true}
              onClick={handleClickNote}
            >
              <NotificationsIcon onClick={handleClick} />
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                style={{ top: "35px" }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                {noteflag && !loaderstate && (
                  <List
                    sx={{
                      width: "250px",
                      bgcolor: "background.paper",
                      padding: "0",
                      maxHeight: 80 * 6,
                      overflowY: "auto",
                    }}
                  >
                    {notelist.map((item) => (
                      <>
                        <ListItem>
                          <ListItemText
                            onClick={handleViewAll}
                            primary={item.Comments}
                            secondary={item.date}
                            className="notification"
                          />
                        </ListItem>
                        <Divider />
                      </>
                    ))}
                  </List>
                )}

                {!noteflag && !loaderstate && (
                  <MenuItem
                    style={{
                      textAlign: "center",
                      display: "block",
                      paddingBottom: "30px",
                      paddingTop: "30px",
                      width: "250px",
                    }}
                  >
                    <NotificationsOffIcon
                      style={{
                        fontSize: "65px",
                        display: "block",
                        margin: "auto",
                        paddingBottom: "15px",
                      }}
                    />
                    no notification
                  </MenuItem>
                )}

                {loaderstate && (
                  <MenuItem
                    style={{
                      textAlign: "center",
                      display: "block",
                      paddingBottom: "30px",
                      paddingTop: "30px",
                      width: "250px",
                    }}
                  >
                    <Loader
                      visible={loaderstate}
                      type="Puff"
                      color="#00BFFF"
                      height={45}
                      width={45}
                      timeout={300000}
                    />
                  </MenuItem>
                )}
                <Divider />
                <MenuItem
                  onClick={handleViewAll}
                  style={{
                    textAlign: "center",
                    display: "block",
                    fontSize: "12px",
                  }}
                >
                  View All
                </MenuItem>
              </Menu>
            </Badge>
          </IconButton>
          <IconButton color="inherit">
            <InputIcon onClick={handlelogout} />
          </IconButton>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};

export default DashboardNavbar;
